<template>
  <pnet-validation-observer>
    <div class="container">
      <div class="row" v-for="(rangeValue, index) in rangeValues" v-bind:key="index">
        <div class="col">
          <label for>
            <small>minT{{index + 1}}</small>
          </label>
          <text-field v-model="rangeValue.from"></text-field>
        </div>
        <div class="col">
          <label for>
            <small>maxT{{index + 1}}</small>
          </label>
          <text-field v-model="rangeValue.to"></text-field>
        </div>
      </div>
    </div>
  </pnet-validation-observer>
</template>

<script lang="js">
import Vue from "vue";
import TextField from "@/components/TextField.vue";
export default Vue.extend({
  props: ["value"],
  components: {
    TextField
  },
  data: function() {
    return {
      rangeValues: [
        {
          order: 0,
          from: "",
          to: "",
          value: ""
        },
        {
          order: 1,
          from: "",
          to: "",
          value: ""
        },
        {
          order: 2,
          from: "",
          to: "",
          value: ""
        },
      ]
    }},
  methods: {
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler(){
        this.rangeValues = this.value;
      }
    },
    rangeValues: {
      deep: true,
      handler(){
        this.$emit('input', this.rangeValues);
      }
    }
  },
  mounted() {
    this.rangeValues = this.value;
  }
});
</script>